import React from 'react';
import { ArrowLeftIcon, ArrowRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function ButtonColorTestPage() {
  return <div className="w-full min-h-screen bg-white py-12 px-6" data-id="element-674">
      <div className="max-w-4xl mx-auto" data-id="element-675">
        {/* Back button */}
        <div className="mb-8" data-id="element-676">
          <Link to="/" className="flex items-center text-gray-600 hover:text-gray-900" data-id="element-677">
            <ArrowLeftIcon size={20} className="mr-2" data-id="element-678" />
            <span data-id="element-679">Go Back</span>
          </Link>
        </div>
        {/* Main content */}
        <div className="bg-gray-50 rounded-xl p-8 shadow-sm border border-gray-100" data-id="element-680">
          <h1 className="text-3xl font-bold text-gray-900 mb-10 text-center" data-id="element-681">
            CTA Button Color Options
          </h1>
          <div className="space-y-12" data-id="element-682">
            {/* Sunset Coral */}
            <div className="space-y-6" data-id="element-683">
              <h2 className="text-xl font-semibold text-gray-800" data-id="element-684">
                Sunset Coral (#f46b5b)
              </h2>
              <div className="flex flex-wrap gap-6" data-id="element-685">
                <button className="bg-[#f46b5b] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-686">
                  <span data-id="element-687">Primary Button</span>
                </button>
                <button className="bg-[#f46b5b] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-688">
                  <span data-id="element-689">Get Started</span>
                  <ArrowRightIcon size={18} data-id="element-690" />
                </button>
                <button className="border-2 border-[#f46b5b] text-[#f46b5b] px-6 py-3 rounded-md font-medium hover:bg-[#f46b5b] hover:text-white transition-colors" data-id="element-691">
                  Secondary Button
                </button>
              </div>
            </div>
            {/* Golden Amber */}
            <div className="space-y-6" data-id="element-692">
              <h2 className="text-xl font-semibold text-gray-800" data-id="element-693">
                Golden Amber (#f6b736)
              </h2>
              <div className="flex flex-wrap gap-6" data-id="element-694">
                <button className="bg-[#f6b736] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-695">
                  <span data-id="element-696">Primary Button</span>
                </button>
                <button className="bg-[#f6b736] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-697">
                  <span data-id="element-698">Get Started</span>
                  <ArrowRightIcon size={18} data-id="element-699" />
                </button>
                <button className="border-2 border-[#f6b736] text-[#f6b736] px-6 py-3 rounded-md font-medium hover:bg-[#f6b736] hover:text-white transition-colors" data-id="element-700">
                  Secondary Button
                </button>
              </div>
            </div>
            {/* Bright Sky Blue */}
            <div className="space-y-6" data-id="element-701">
              <h2 className="text-xl font-semibold text-gray-800" data-id="element-702">
                Bright Sky Blue (#4dc4f7)
              </h2>
              <div className="flex flex-wrap gap-6" data-id="element-703">
                <button className="bg-[#4dc4f7] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-704">
                  <span data-id="element-705">Primary Button</span>
                </button>
                <button className="bg-[#4dc4f7] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-706">
                  <span data-id="element-707">Get Started</span>
                  <ArrowRightIcon size={18} data-id="element-708" />
                </button>
                <button className="border-2 border-[#4dc4f7] text-[#4dc4f7] px-6 py-3 rounded-md font-medium hover:bg-[#4dc4f7] hover:text-white transition-colors" data-id="element-709">
                  Secondary Button
                </button>
              </div>
            </div>
            {/* Comparison Section */}
            <div className="pt-10 border-t border-gray-200" data-id="element-710">
              <h2 className="text-xl font-semibold text-gray-800 mb-6" data-id="element-711">
                Side-by-Side Comparison
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-712">
                <button className="bg-[#f46b5b] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-713">
                  <span data-id="element-714">Sunset Coral</span>
                  <ArrowRightIcon size={18} data-id="element-715" />
                </button>
                <button className="bg-[#f6b736] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-716">
                  <span data-id="element-717">Golden Amber</span>
                  <ArrowRightIcon size={18} data-id="element-718" />
                </button>
                <button className="bg-[#4dc4f7] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-719">
                  <span data-id="element-720">Bright Sky Blue</span>
                  <ArrowRightIcon size={18} data-id="element-721" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}